import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Box from "@material-ui/core/Box";
import Grid from "@material-ui/core/Grid";
import Card from "@material-ui/core/Card";
import CardActionArea from "@material-ui/core/CardActionArea";
import CardContent from "@material-ui/core/CardContent";
import CardMedia from "@material-ui/core/CardMedia";
import Typography from "@material-ui/core/Typography";

import project1 from "../images/opendet.jpg";
import project2 from "../images/VaporDeposition.jpg";
import Rotoforge from "../images/rotoforge-1.png";
import ERV from "../images/ERV.png";
import Workshop from "../images/shed.jpg";
import sputter from "../images/sputter.jpg";
import measuring from "../images/measuring.jpg";

const useStyles = makeStyles((theme) => ({
  mainContainer: {
    background: "transparent",
    height: "100%",
    paddingTop: theme.spacing(4),
  },
  titleBox: {
    background: "rgba(0, 0, 0, 0.8)",
    padding: theme.spacing(1, 3),
    marginBottom: theme.spacing(4),
    textAlign: "center",
    width: "fit-content", // Key for dynamic width
    maxWidth: "100%", // Prevent overflow on small screens
    margin: "0 auto",
    borderRadius: 20, // Adjust the radius for desired roundness
  },
  titleText: {
    color: "white", // Set title text color
    textShadow: "0 2px 8px rgba(0, 0, 0, 0.9)",
  },
  cardContainer: {
    maxWidth: 345,
    margin: "3rem auto",
    background: "rgba(0, 0, 0, 0.8)",
    color: "white",
  },
  cardDescription: {
    color: "rgba(255, 255, 255, 0.7)",
  },
}));

const projects = [
  {
    name: "Open Detonation Spray",
    description: `While studying efficient metal deposition methods for the Infini-z print-in-place printer project, I discovered cold-spray
    technology as a potential candidate. However, the complex components needed for the system made it challenging to design for
    full printability. To address this challenge, I developed Open Detonation Spray, a printable small-scale pulsed-detonation
    spray 3D printer proof of concept. so far I have been able to reliably deposit copper on nickel and on PLA.
    `,
    image: project1,
    url: "https://github.com/avery-lockwood/OpenDetonationSpray"
  },
  {
    //add link to paper i am basing my work off of
    name: "Lithium Sulphur Battery Chemistry & soft-vacuum pvd",
    description: `After reading a research paper about carbon nanotubes to stabilize monoclinic gamma sulfur
    in lithium sulfur batteries to yield much higher lifetime than other techniques. I wanted to try using 
    vertically aligned graphene sheets as a cheaper alternative to the graphenes used in the paper.
     I built my own soft-vacuum pvd system to vapor deposit the sulfur and am currently looking for a 
     lab to assemble and test cells with.`,
    image: project2,
    url: "https://github.com/avery-lockwood/Soft-Vaccum-Pvd"
  },
  {
    name: "Rotoforge Contributions",
    description: `
    I am now working with Sindry Manufacturing to develop an affordable, small scale friction surfacing based metal 3d printer
    The current prototype I am working on is an orbital friction welding system. I designed a simple, but strong `,
    image: Rotoforge,
    url: "https://github.com/Sindry-Manufacturing/rotoforge",
  },
  {
    name: "Erv Forge build",
    description: `For the Crucible's ERV (Educational Response Vehicle), I designed and built a forge that is reliable, 
    efficient, and very repairable. This project included designing the forge and other equipment to be portable 
    and repairable in the field. `,
    image: ERV,
    url: "https://www.thecrucible.org/erv-2022/",
  },
  {
    name: "My Workshop",
    description: `A small building that I built with my grandpa as a kid, I've been tooling up my shop
    ever since to do everything from jewelry, simple chemistry, machining and electronics.`,
    image: Workshop,
  },
  {
    name: "Simple Sputter Coater",
    description: `A small, simple, manufacturable sputter coating system for lab scale coating on a budget`,
    image: sputter,
    url: "https://github.com/avery-lockwood/Simple-Sputter-Coater"

  },
  {
    name: "odds and ends",
    description: `here is some of my work that doesn't quite fit into a single project`,
    image: measuring,
    url: "/miscellaneous",
  },
];

const Portfolio = () => {
  const classes = useStyles();
  return (
    
    <Box component="div" className={classes.mainContainer}>
        <Box className={classes.titleBox}>
            <Typography variant="h3" className={classes.titleText}>
            <span>✨</span> Here's what I've been working on (^> <span>✨</span>
            </Typography>
          </Box>
      <Grid container justify="center">
         
        {/* Projects */}
        {projects.map((project, i) => (
          <Grid item xs={12} sm={8} md={4} key={i}>
            <Card className={classes.cardContainer}>
            <a href={project.url} key={i} style={{textDecoration: "none", color: "inherit"}}>
              <CardActionArea>
                <CardMedia
                  component="img"
                  alt="Project 1"
                  height="140"
                  image={project.image}
                />
                <CardContent>
                  <Typography variant="h5" gutterBottom>
                    {project.name}
                  </Typography>
                  <Typography variant="body2" className={classes.cardDescription}>
                    {project.description}
                  </Typography>
                </CardContent>
              </CardActionArea>
              </a>
            </Card> 
           
          </Grid>
        ))} 
      </Grid>
    </Box>
  );
};

export default Portfolio;
